



















































































import settings from '@/settings'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import q from '@/graphql/query'
import m from '@/graphql/mutation'
import af from '@/utils/authorized_formats'

export default {
    name: 'users_payslips'

    props:
        uid:
            type: String

    data: ()->
        dialog_visible: false
        errors: {}
        loading: true
        alert: false
        search: ''
        pager_count: 5
        current_page: 1
        page_size: 10
        active_names: [1]
        false: false
        readonly: false
        max_filesize: af['pay_slip']['file']['max_filesize']/1024/1024
        authorized_formats: af['pay_slip']['file']['authorized_formats']
        payslip: {
            uid: ''
            user_uid: @uid
            date: ""
            file_name: ""
            file_data: ""
        }
        payslips: []

    computed:
        data_filtered: ()->
            self = @
            data = @payslips.filter (x) ->
                !self.search || x.date.toString().toLowerCase().includes(self.search.toLowerCase())
            return data

        data_paged: ()->
            data = @data_filtered.slice(((@current_page - 1) * @page_size), (@page_size * @current_page))
            return data

        toggle_collapse_text: ()->
            text = "Ajouter un bulletin de salaire"
            if @active_names.length > 1
                text = "Fermer"
            return text

        toggle_collapse_icon: ()->
            class_icon = 'mdi-plus-circle-o'
            if @active_names.length > 1
                class_icon = 'mdi-close-circle-o'
            return class_icon

        has_mutation_right: ()->
            return @has_access_right(@get_access('edit'))

        has_deletion_right: ()->
            return @has_access_right(@get_access('delete'))

    methods:
        has_access_right: t.has_access_right

        listen_sort: ({ column, prop, order })->
            # console.log "LISTEN", column, prop, order
            self = @
            @payslips.sort (a,b)->
                modifier = 1
                if order == 'descending'
                    modifier = -1
                return a[prop].toLowerCase().localeCompare(b[prop].toLowerCase())*modifier

        handle_size_change: (val)->
            @page_size = val

        handle_current_change: (val)->
            @current_page = val

        get_errors: (fieldName)->
            ret = null
            if @errors[fieldName]?
                ret = @errors[fieldName][0]
            return ret

        date_formatter: (date)->
            new_date = ""
            if date?
                date_array = date.split('-')
                new_date = date_array[0]+'/'+date_array[1]
            return new_date

        reset_payslip: ()->
            @payslip = {
                uid: ''
                user_uid: @uid
                date: ""
                file_name: ""
                file_data: ""
            }
            return

        collapse_change: (value)->
            # console.log "VUE TOGGLE ", value
            @errors = {}
            @reset_payslip()
            @$refs.payslip_upload.clearFiles()
            return

        handle_file_remove: (file, fileList)->
            @$refs.payslip_upload.clearFiles()
            @payslip.file_data = ''
            @payslip.file_name = ''
            return

        handle_file_change: (file, fileList)->
            is_good_ext = file.raw.type in af['pay_slip']['file']['mime_types']
            is_good_size = file.size < af['pay_slip']['file']['max_filesize']

            if !is_good_ext
                n.file_error('Erreur', 'Le fichier doit être de type '+@authorized_formats+'.')
                fileList.pop()
                return
            if !is_good_size
                n.file_error('Erreur', 'Le fichier ne peut pas excéder '+@max_filesize+'Mo.')
                fileList.pop()
                return

            self = @
            if fileList.length > 1
                fileList.splice(0,1)
            reader = new FileReader()
            reader.onload = (e)->
                # console.log 'E', e
                self.payslip.file_data = e.target.result
                self.payslip.file_name = file.name
            reader.readAsDataURL(file.raw)
            # console.log "FILE", @payslip
            return

        download_file: (payslip)->
            url = settings.media_url+payslip.file_dir+'/'+payslip.file
            filename = payslip.complete_filename
            t.download_file(url, filename)
            return

        edit_payslip: (payslip)->
            @active_names = [1]
            @payslip.uid = payslip.uid
            @payslip.date = payslip.date
            @dialog_visible = true
            @errors = {}
            return

        get_access: (suffix)->
            access = "pay_slips_self_"+suffix
            if @$route.name == 'company_users_pay_slips'
                access = "pay_slips_"+suffix
            return access

        delete_payslip: (payslip_uid)->
            self = @
            @$confirm("Êtes-vous sûr·e de vouloir supprimer ce bulletin de salaire ?", 'Confirmation', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    m.run('delete_object', ['pay_slip', payslip_uid])
                    .then (resp)->
                        if resp.body.data.pay_slip_deletion.ok
                            n.success()
                            self.get_payslips()
                        else
                            n.gql_error("users_payslips: delete_payslip: then", resp.body.data.pay_slip_deletion.message)
                    .catch (resp)->
                        n.catch_error(resp, "users_payslips: delete_payslip()")
                .catch (cancel)->
                    return

        save: ()->
            self = @
            @payslip.user_uid = @uid
            if @payslip.uid == '' and @payslip.file_name == ""
                n.file_error('Erreur', 'Un fichier est requis')
                return
            m.run('save_payslip', [@payslip])
            .then (resp)->
                if resp.body.data.pay_slip_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.pay_slip_form_mutation.errors.length > 0
                    self.errors = resp.body.data.pay_slip_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                    n.form_error()
                else
                    self.errors = {}
                    n.success()
                    self.reset_payslip()
                    self.active_names = [1]
                    self.dialog_visible = false
                    self.$refs.payslip_upload.clearFiles()
                    self.get_payslips()
            .catch (resp)->
                n.catch_error(resp, "users_payslips: save()")

        get_payslips: ()->
            self = @
            @loading = true
            q.run('get_payslip_set', [@uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("users_payslips: get_payslips: then", e.message)
                else
                    # console.log "GET PAYSLIPS : ", resp.body.data.pay_slip_set
                    self.payslips = resp.body.data.pay_slip_set
                    self.loading = false
                    if self.payslips.length == 0
                        self.alert = true
                    else
                        self.alert = false
            .catch (resp)->
                n.catch_error(resp, "users_payslips: get_payslips()")
            
    beforeMount: ()->
        # console.log "PAYSLIPS MOUNT"
        if @uid != '0'
            @get_payslips()
}
